import styled from "@emotion/styled";
import { Button, IconButton } from "@mui/material";
// import { Box, styled } from "@mui/material";
import { Box } from "@mui/system";
import { slideInBottom, slideInRight } from "../styles/animation";
import { Colors } from "../styles/themeStyle";


export const Product = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  // width: "280px",
  height: 420,
  overflow: "hidden",

   // הופך את זה לכרטיס:
  padding: theme.spacing(3),           // ריווח פנימי (כמו margin בתוך המסגרת)
  borderRadius: "24px",                // קצוות עגולים (תשני מספר לפי כמה עגול את רוצה)
  border: "1px solid #D81B60",         // צבע המסגרת (טורקיז כמו בתמונה בערך)
  backgroundColor: "#fff",             // רקע לבן בתוך הכרטיס
  boxSizing: "border-box",             // שהרוחב יכלול את ה־padding

  [theme.breakpoints.up("md")]: {
    position: "relative",
  },
    "&:hover": {
    borderColor:  "#D81B60"  ,      // ורוד חזק יותר במסגרת
    boxShadow: "0 0 0 5px rgba(216, 27, 96, 0.2)", // אפקט מודגש יותר (אופציונלי)
  },

}));

export const ProductImage = styled("img")(({width, src, theme }) => ({
  // src: `url(${src})`,
  width:  "175px",
  height: "175px",
  objectFit: "contain",
 
  // background: Colors.light_gray,
  // padding: '10px',
  [theme.breakpoints.down("md")]: {
    width: "80%", 
    // padding: '24px',
  },
}));

export const ProductImageWrap = styled("div")(() => ({
  width: 175,
  height: 175,
  padding: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
    // border: "2px dashed red",
  
}));


export const ProductActionButton = styled(IconButton)(() => ({
  background: Colors.white,
  position:"center",  margin: 4,
  
}));

export const ProductFavButton = styled(ProductActionButton)(({ isfav, theme }) => ({
  color: isfav ? Colors.primary : Colors.light,  
  [theme.breakpoints.up("md")]: {
    position: "absolute",
    right: 0,
    top: 0,
  },
}));

export const ProductAddToCart = styled(Button, {
  shouldForwardProp: (prop) => prop !== "show",
})(({ show, theme }) => ({
  width: "100px",
   height: 50,  
  fontSize: "12px",
   // צבעים בסיסיים
  backgroundColor: "#FFFFFF",       // מילוי לבן
  border: "1px solid #D81B60",      // מסגרת ורודה
  color: "#0c0b0bff",                 // טקסט ורוד

  // hover – הכפתור נהיה ורוד
  "&:hover": {
    backgroundColor: "#D81B60",
    color: "#FFFFFF",
    borderColor: "#D81B60",
  },
  [theme.breakpoints.up("md")]: {
    // position: "absolute",    
    // bottom: "2%",
    width: "150px",
    padding: "7px 5px",
    fontSize:'20px',
    margin: '2px',
    animation:
      show &&
      `${slideInBottom} 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`,
  },
  // background: "#D81B60",
  opacity: 0.9,
}));

export const ProductAddToCartChat = styled(Button, {
  shouldForwardProp: (prop) => prop !== "show",
})(({theme}) => ({
  
  fontSize: "12px",
  [theme.breakpoints.up("md")]: {
    position: "absolute", 
  },   
  bottom: "2%",
  padding: "4px 4px",
  background: Colors.primary,
  opacity: 0.85,
}));

export const ProductMetaWrapper = styled(Box)(({theme}) => ({
  padding: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const ProductActionsWrapper = styled(Box)(({ show, theme }) => ({ 
  [theme.breakpoints.up("md")]: {
    // display: show ? 'visible' : 'none',
    position: "absolute",
    right: 0,
    top: '10%',
    animation: show && `${slideInRight} 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`,
  }
}));

export const ProductActionsWrapperChat = styled(Box)(({ show, theme }) => ({ 
  [theme.breakpoints.up("md")]: {
    display: show ? 'visible' : 'none',
    left: 0,
    top: '20%',
    animation: show && `${slideInRight} 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`,
  }
}));

export const ProductCountAction = styled(Button, {
  shouldForwardProp: (prop) => prop !== "show",
})(({ show, theme }) => ({
  width: "120px",
  fontSize: "12px",
  [theme.breakpoints.up("md")]: {
    // position: "absolute",    
    // bottom: "2%",
    width: "50px",
    fontSize:'20px',
    // padding: "10px 5px",
    animation:
      show &&
      `${slideInBottom} 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`,
  },
  background: Colors.secondary,
  opacity: 0.9,
}));



// הקונטיינר החיצוני
export const CounterWrapper = styled(Box)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",

    width: 38,
    minWidth: 38,
    flexShrink: 0,

    borderRadius: 4,
    backgroundColor: "#666",
    alignItems: "stretch",
    overflow: "visible",
    boxSizing: "border-box",

    [theme.breakpoints.up("sm")]: {
      width: 44,
      minWidth: 44,
    },

    [theme.breakpoints.up("md")]: {
      width: 50,
      minWidth: 50,
    },
  })
);

// כפתורי הפלוס והמינוס
export const CounterArrow = styled("button")(() => ({
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",

  border: "none",
  backgroundColor: "#58A76B",
  color: "#fff",

  height: 15,
  minHeight: 15,

  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  position: "relative",

  "&:hover": {
    backgroundColor: "#478a58",
  },

  "&:focus": {
    outline: "none",
  },

  "&:focus-visible": {
    outline: "3px solid #D81B60",
    outlineOffset: "3px",
    zIndex: 2,
  },

  "&:disabled": {
    opacity: 0.4,
    cursor: "not-allowed",
  },
}));

// שדה הכמות
export const CounterValue = styled("input")(() => ({
  backgroundColor: "#fff",
  color: "#000",
  height: 20,
  fontSize: 14,
  textAlign: "center",
  border: "1px solid transparent",
  boxSizing: "border-box",
  width: "100%",
minWidth: 0,
padding: 0,

  "&:focus": {
    outline: "none",
  },

  "&:focus-visible": {
    outline: "3px solid #D81B60",
    outlineOffset: "3px",
    position: "relative",
    zIndex: 2,
  },

  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },

  "&[type=number]": {
    MozAppearance: "textfield",
  },
}));

